<template>
  <div class="messages">
    <div class="title">
      留言管理
    </div>
    <el-form
      ref="formTop"
      v-model="formTop"
      :inline="true"
      label-width="68px"
    >
      <el-form-item label>
        <el-input
          v-model="formTop.zip"
          class="search"
          placeholder="樓盤編號"
          suffix-icon="el-icon-search"
        />
      </el-form-item>
      <el-form-item label="留言時間:">
        <el-date-picker
          v-model="formTop.startTime"
          class="time"
          type="date"
          :picker-options="startTimeOption"
          placeholder="選擇日期"
        />

        <el-date-picker
          v-model="formTop.endTime"
          class="time"
          type="date"
          :picker-options="endTimeOption"
          placeholder="選擇日期"
        />
      </el-form-item>

      <el-form-item class="btn-item">
        <el-button
          class="btn"
          type="danger"
          @click="handleQuery"
        >
          搜尋
        </el-button>
        <el-button
          class="btn"
          type="info"
          @click="handleReset"
        >
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <el-divider />
    <div
      class="operat"
      :class="{ button: true, fixed: isFixed, 'fixed-1': !sideBar }"
    >
      <span
        class="btn-icon"
        content="查看樓盤"
        placement="top"
        @click="goUrl(department)"
      >
        <svg
          class="icon"
          aria-hidden="true"
          style="width:1.7em;height:1.7em"
        >
          <use :xlink:href="!department || selected ? '#iconchakanloupan' : '#iconchakanloupan-copy'" />
        </svg>
        <span :class="{ 'btn-text': true, ban: !department || selected }">查看樓盤</span>
      </span>
      <template v-if="!isDisabledPublish">
        <span
          class="btn-icon"
          content="回覆"
          placement="top"
          @click="handleUpdate(department, 1)"
        >
          <svg
            class="icon"
            aria-hidden="true"
            style="width:1.5em;height:1.5em"
          >
            <use :xlink:href="!department || department.replyMessage || selected || accountID !== department.property.accountID ? '#iconhuifu' : '#iconhuifu-copy'" />
          </svg>
          <span :class="{ 'btn-text': true, ban: !department || department.replyMessage || selected || accountID !== department.property.accountID }">回覆</span>
        </span>
        <span
          class="btn-icon"
          content="修改留言"
          placement="top"
          @click="handleUpdate(department, 2)"
        >
          <svg
            class="icon"
            aria-hidden="true"
            style="width:1.5em;height:1.5em"
          >
            <use :xlink:href="!department || !department.replyMessage || selected || accountID !== department.property.accountID ? '#iconxiugai' : '#iconxiugai-copy'" />
          </svg>
          <span :class="{ 'btn-text': true, ban: !department || !department.replyMessage || selected || accountID !== department.property.accountID }">修改</span>
        </span>
        <span
          class="btn-icon"
          content="刪除"
          placement="top"
          @click="deleteRow(department)"
        >
          <svg
            class="icon"
            aria-hidden="true"
            style="width:1.5em;height:1.5em"
          >
            <use :xlink:href="!department || selected || accountID !== department.property.accountID ? '#iconshanchu1' : '#iconshanchu1-copy'" />
          </svg>
          <span :class="{ 'btn-text': true, ban: !department || selected || accountID !== department.property.accountID }">刪除</span>
        </span>
      </template>
    </div>
    <div class="table">
      <!-- 文字列表 -->
      <div class="text-list">
        <el-table
          ref="yyTab"
          :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444444', fontSize: '13px', fontWeight: 400 }"
          :header-row-style="setHeaderRowStyle"
          :data="tableData"
          empty-text="暫無數據"
          style="width: 100%;"
          @select="handleSelection"
        >
          <el-table-column type="selection" />
          <!-- <el-table-column :selectable="isDisabled" type="selection" width="55" fixed="left"></el-table-column> -->
          <el-table-column
            prop="property.propertyID"
            label="樓盤編號"
            min-width="90"
          />
          <el-table-column
            prop="contactName"
            label="留言用戶"
            min-width="100"
          />
          <el-table-column
            prop="contactWay"
            label="聯絡電話"
            min-width="100"
          />
          <el-table-column
            label="留言內容"
            min-width="200"
          >
            <!--  prop="leaveMessage" -->
            <template slot-scope="scope">
              {{ scope.row.leaveMessage?scope.row.leaveMessage:'-' }}
            </template>
          </el-table-column>
          <el-table-column
            label="留言時間"
            min-width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime | getTime }}
            </template>
          </el-table-column>
          <el-table-column
            label="回覆內容"
            min-width="200"
          >
            <template slot-scope="scope">
              <!-- <el-dropdown :hide-timeout="moreTagsHideTimeout" placement="top">
                                <span class="el-dropdown-link">
                                    <div class="messhow">{{ scope.row.replyMessage?scope.row.replyMessage:'-' }}</div>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <div class="properyty-mes-more-dropdown">
                                        {{scope.row.replyMessage}}
                                    </div>
                                </el-dropdown-menu>
                            </el-dropdown> -->
              {{ scope.row.replyMessage ? scope.row.replyMessage : '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="property.accountName"
            label="回覆人"
            min-width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.replyMessage ? scope.row.property.accountName : '-' }}
            </template>
          </el-table-column>
          <el-table-column
            label="回覆時間"
            min-width="100"
          >
            <span slot-scope="score">
              <template v-if="score.row.replyMessage">{{ score.row.replyTime | getTime }}</template>
              <template
                v-else
              >-</template>
            </span>
          </el-table-column>
          <el-table-column
            v-if="false"
            class="operating"
            fixed="right"
            label="操作"
            width="140"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="goUrl(scope.row)"
              >
                查看樓盤
              </el-button>
              <el-button
                v-show="accountID === scope.row.property.accountID"
                :disabled="!!scope.row.replyMessage"
                type="text"
                size="small"
                @click.native.prevent="handleUpdate(scope.row, 1)"
              >
                回覆
              </el-button>
              <br>
              <el-button
                v-show="accountID === scope.row.property.accountID"
                type="text"
                size="small"
                :disabled="!scope.row.replyMessage"
                @click.native.prevent="handleUpdate(scope.row, 2)"
              >
                修改留言
              </el-button>
              <el-button
                v-show="accountID === scope.row.property.accountID"
                type="text"
                size="small"
                @click.native.prevent="deleteRow(scope.row)"
              >
                刪除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <!-- <span>當前查詢記錄：{{ count }}</span> -->
        <!-- <span>總記錄：{{ countNum }}</span> -->
        <!-- <el-input-number
          class="input-number"
          v-model="pageCount"
          controls-position="right"
          @change="handleChange"
          :min="1"
          :max="50"
          size="small"
        ></el-input-number>-->
        <el-pagination
          class="page"
          background
          :current-page="currentPage4"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="count"
          @size-change="handleSizeChange"
          @current-change="currentChange"
        />
        <!-- <el-pagination 
          class="page" 
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageCount" 
          :current-page="pageIndex" 
          @size-change="handleSizeChange"
          @current-change="currentChange" 
          background 
          layout="prev, pager, next" 
          :total="count"
        ></el-pagination>-->
      </div>
    </div>

    <!-- 添加或修改公告对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="open"
      :before-close="handleClose"
      width="780px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="160px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="你的聯絡電話:"
              prop="replyTelephone"
            >
              <el-input
                v-model="form.replyTelephone"
                type="tel"
                maxlength="8"
                placeholder="請輸入内容"
                @input="handleInput"
              />
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item
              label="你的回覆:"
              prop="replyMessage"
              :rules="{ required: true, message: '請輸入你的回覆', trigger: 'blur' }"
            >
              <el-input
                v-model="form.replyMessage"
                type="textarea"
                :rows="5"
                maxlength="200"
                placeholder="請輸入内容"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="padding-top:20px"
      >
        <el-button
          class="btn"
          @click="handleClose"
        >
          取 消
        </el-button>
        <el-button
          class="btn"
          type="primary"
          @click="submitForm('form')"
        >
          確 認
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'Messages',
    watch: {
        /**判断滚动距离 */
        scrollValue(val) {
            if (val >= 120) {
                this.isFixed = true;
            } else {
                this.isFixed = false;
            }
        }
    },
    computed: {
        ...mapGetters(['page', 'sideBar'])
    },
    data() {
        var checkTel = (rule, value, callback) => {
            let reg = /^[01].*/;
            if (value === '') {
                callback(new Error('請輸入電話'));
            } else if (reg.test(value)) {
                callback(new Error('不能以0或1開頭'));
            } else {
                callback();
            }
        };
        return {
            moreTagsHideTimeout: 360,
            isDisabledPublish:false,
            accountID: this.$store.state.userInfo.accountID,
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            //头部搜索表单
            formTop: {
                zip: '',
                startTime: '',
                endTime: ''
            },
            // 修改留言弹窗表单
            form: {
                replyTelephone: this.$store.state.userInfo.telephone,
                replyMessage: ''
            },
            // 表单校验
            rules: {
                replyTelephone: [{ required: true, validator: checkTel, trigger: 'blur' }]
            },
            tableData: [],
            // 留言信息
            pageCount: 10, //每页数据量
            pageIndex: 1, // 当前页数
            count: 0,
            countNum: 0,
            // 当前活动留言
            active: '', // 1-回复，2-更改
            updateQuery: {} /**更新留言参数 */,
            /** 留言列表参数*/
            listQuery: {
                LikePropertyID: null, //房源Id
                startTime: null,
                endTime: null,
                pageIndex: 1,
                pageCount: 10
            },
            currentPage4: 1,
            startTimeOption: {
                disabledDate: this.startTimeOption1
            },
            endTimeOption: {
                disabledDate: this.endTimeOption1
            },
            selected: false,
            department: '',
            radio: '',
            isFixed: false,
            /**滚动值 */
            scrollValue: 0
        };
    },
    created() {
        this.pub.getcompanyCategorys().then((res)=>{
            this.isDisabledPublish = res
        })
        this.listQuery.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID,'messagePageCount') || 10
        this.pageCount = this.listQuery.pageCount;
        this.listQuery.pageCount = this.listQuery.pageCount;
        this.messageList();
    },
    mounted() {
        document.querySelector('.el-main').addEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.scrollValue = document.querySelector('.el-main').scrollTop;
        },
        handleSelection(selection, row) {
            this.$refs.yyTab.clearSelection();
            if (selection.length === 0) {
                // return
                this.selected = true;
                this.department = '';
                return;
            } 
                this.selected = false;
            
            this.$refs.yyTab.toggleRowSelection(row);
            this.department = row;
        },
        setHeaderRowStyle(row, rowIndex) {
            if (rowIndex === 0) {
                return {
                    display: 'none'
                };
                return {};
            }
        },
        /**时间选择 */
        startTimeOption1(time) {
            if (this.formTop.endTime) {
                return time.getTime() > this.formTop.endTime;
            } 
                return false;
            
        },
        endTimeOption1(time) {
            if (this.formTop.startTime) {
                return time.getTime() < this.formTop.startTime;
            } 
                return false;
            
        },
        handleChange() {
            this.listQuery.pageCount = this.pageCount;
            this.messageList();
        },
        handleSizeChange(val) {
            this.pub.userPageSize(this.$store.state.userInfo.accountID,'messagePageCount',val)
            this.pageCount = val;
            this.listQuery.pageCount = val;
            this.messageList();
        },
        deleteRow(a, b) {
            if (!a || this.accountID !== this.department.property.accountID) {return;}
            this.$confirm('此操作將永久刪除該條數據, 是否繼續?', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    /**删除留言 */
                    this.axios
                        .get(this.pub.getApi().DeleteLeaveMessage, {
                            params: {
                                messageId: a.messageID
                            }
                        })
                        .then(res => {
                            if (Number(res.data.code) === 0) {
                                if (res.data.result) {
                                    this.messageList();
                                    this.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: '刪除成功!'
                                    });
                                }
                            }
                        });
                })
                .catch(e => {
                    this.$message({
                        showClose: true,
                        type: 'info',
                        message: '已取消刪除'
                    });
                });
        },
        messageList() {
            this.axios.post(this.pub.getApi().SearchLeaveMessage, this.listQuery).then(res => {
                if (Number(res.data.code) === 0) {
                    this.tableData = [...res.data.result.data];
                    this.count = res.data.result.count;
                    this.countNum = this.count;
                }
            });
        },
        goUrl(a) {
            if (a.property.rentalType === 1) {
                window.open(`${this.pub.config.pcUrl}buy-property-${a.property.propertyID}.html`, '_blank');
            } else if (a.property.rentalType === 2) {
                window.open(`${this.pub.config.pcUrl}rent-property-${a.property.propertyID}.html`, '_blank');
            }
        },
        currentChange(pageIndex) {
            this.listQuery.pageIndex = pageIndex;
            this.pageIndex = pageIndex;
            this.messageList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.listQuery.LikePropertyID = this.formTop.zip ? parseInt(this.formTop.zip) : null;
            this.listQuery.pageIndex = 1;
            this.pageIndex = 1;
            if (this.formTop.startTime || this.formTop.endTime) {
                this.listQuery.startTime = this.formTop.startTime ? this.formTop.startTime.getTime() / 1000 : null;
                this.listQuery.endTime = this.formTop.endTime ? this.formTop.endTime.getTime() / 1000 + 24 * 60 * 60 : null;
            } else {
                this.listQuery.startTime = null;
                this.listQuery.endTime = null;
            }
            this.messageList();
        },
        /** 重置按钮操作 */
        handleReset() {
            this.formTop = {
                zip: '',
                startTime: '',
                endTime: ''
            };
            this.listQuery.LikePropertyID = null;
            this.listQuery.startTime = '';
            this.listQuery.endTime = '';
            this.messageList();
        },
        /**回复、更改留言 */
        handleUpdate(a, active) {
            if (!a || this.accountID !== this.department.property.accountID) {return;}
            if (active === 1 && a.replyMessage) {
                return;
            } else if (active === 2 && !a.replyMessage) {
                return;
            }
            this.form = {
                replyMessage: a.replyMessage,
                replyTelephone: a.replyTelephone ? a.replyTelephone : this.$store.state.userInfo.telephone
            };
            if (active === 1) {
                this.title = '回覆此留言';
            } else if (active === 2) {
                this.title = '修改此留言';
            }
            this.updateQuery.messageID = a.messageID;
            this.active = active;
            this.open = true;
        },
        /** 提交按钮 */
        submitForm(form) {
            this.$refs[form].validate(valid => {
                if (valid) {
                    this.updateQuery = { ...this.updateQuery, ...this.form };
                    this.axios.post(this.pub.getApi().ReplyLeaveMessage, this.updateQuery).then(res => {
                        if (Number(res.data.code) === 0) {
                            if (res.data.result) {
                                this.open = false;
                                (this.department = ''), (this.selected = false);
                                this.messageList();
                            }
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        /**关闭弹框按钮 */
        handleClose() {
            this.open = false;
        },
        handleInput(val) {
            let num = parseInt(val);
            if (isNaN(num)) {num = '';}
            this.form.replyTelephone = String(num);
        },
        /**是否可選 */
        isDisabled(val) {
            if (this.userInfo.accountID === val.accountID || this.isAdmin) {
                return true;
            } 
                return false;
            
        }
    }
};
</script>
<style lang="less">
.properyty-mes-more-dropdown{
    color: #222;
    padding: 0 6px;
    font-size: 14px;
    max-width: 280px;
    word-break: break-all;
}
.messages {
    text-align: left;
    .title {
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #171725;
        letter-spacing: 0.1px;
        padding-bottom: 20px;
    }
    .search {
        width: 130px;
    }
    .el-form-item__label {
        color: #666666;
        padding-right: 5px;
    }
    .el-input--suffix .el-input__inner {
        border: none;
        border-radius: 10px;
        color: #000000;
        font-size: 14px;
    }
    .el-range-editor.el-input__inner {
        border-radius: 10px;
    }
    .el-table tbody tr:hover > td {
        background-color: rgba(80, 181, 255, 0.1) !important;
    }
    .el-table .el-table__cell {
        padding: 13px 0;
    }
    .time {
        width: 150px;
        margin-right: 10px;
    }
    .btn-item {
        margin-left: 5px;
        .btn {
            width: 88px;
            border-radius: 10px;
        }
    }
    .el-table thead tr {
        background-color: #fafafb;
        th {
            padding: 7px 0;
        }
    }
    .el-dialog {
        border-radius: 10px;
        overflow: hidden;
        .el-input__inner,
        .el-textarea__inner {
            border-radius: 15px;
        }
        .el-button {
            border-radius: 10px;
            border-color: #dbdbdb;
            font-size: 14px;
            width: 95px;
            height: 38px;
        }
        .el-button--primary {
            background-color: #0064ff;
            border-color: #0064ff;
        }
        .el-dialog__title {
            color: #666666;
            font-size: 16px;
            font-weight: 600;
        }
        .el-form-item__label {
            font-size: 14px;
            color: #222222;
        }
    }
    .el-dialog__header {
        padding: 0px 30px;
        height: 42px;
        line-height: 42px;
        background: #fafafb;
        font-size: 16px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom: 1px solid #e2e2ea;
        font-family: PingFangSC-Semibold;
        border-radius: 10px 10px 0 0;
    }
    .el-dialog__headerbtn {
        top: 13px;
    }
    .table {
        padding: 20px;
        background: #fff;
        border-radius: 20px;
        .messhow{
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            display: -webkit-box;
        }
        
        /deep/ .el-table thead tr {
            th:first-child {
                border-radius: 10px 0 0 10px;
            }
            th:nth-last-child(2) {
                border-radius: 0 10px 10px 0;
            }
        }
        .el-table {
            .cell {
                line-height: 24px;
            }
        }
        .el-table thead tr {
            background-color: #fafafb;
        }
        // .el-table td {
        //   // border-bottom: 1px solid #e2e2ea;
        // }
        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #0062ff;
            border-color: #0062ff;
        }
        table {
            color: #222222;
        }
        tbody {
            .el-table__row {
                height: 72px;
            }
        }
    }
    .el-table td .el-table__header-wrapper .el-checkbox__input {
        display: none;
    }
    width: 100%;
    border-radius: 20px;
    box-sizing: border-box;
    .img-list {
        .r-btn {
            padding-right: 12px;
            margin-top: 16px;
            width: 100%;
            border-top: 1px solid #eee;
            padding-top: 6px;
            box-sizing: border-box;
            .el-button {
                padding-left: 12px;
                float: right;
            }
        }
        td {
            position: relative;
        }
        .cell .img {
            text-align: center;
        }
        .cell img {
            position: absolute;
            left: 8px;
            top: 18px;
        }
        .title {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 700;
            font-size: 17px;
            line-height: 24px;
            color: #333333;
            padding: 0;
        }
        .detail {
            .fl {
                flex: 1;
                color: #999;
            }
            .fr {
                color: #666;
                text-align: right;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .adress {
                padding-left: 20px;
                color: #666;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .red {
                color: #ed1d25;
            }
        }
    }
    .footer {
        span {
            font-size: 14px;
            color: #44444f;

            margin-left: 16px;
        }
        margin-top: 16px;
        // border-top: 1px solid #e2e2ea;
        padding-top: 20px;
        box-sizing: border-box;
        height: 72px;
        .page {
            float: right;
        }
        .input-number {
            text-align: left;
            float: right;
            width: 70px;
        }
        /**覆盖计数器样式 */
        .el-input-number.is-controls-right .el-input__inner {
            padding-left: 8px;
            padding-right: 42px;
        }
    }
    .footer {
        span {
            font-size: 14px;
            color: #44444f;

            margin-left: 16px;
        }
        margin-top: 16px;
        // border-top: 1px solid #e2e2ea;
        padding-top: 20px;
        box-sizing: border-box;
        height: 72px;
        .page {
            float: right;
        }
        .input-number {
            text-align: left;
            float: right;
            width: 70px;
        }
        /**覆盖计数器样式 */
        .el-input-number.is-controls-right .el-input__inner {
            padding-left: 8px;
            padding-right: 42px;
        }
    }
    .el-card {
        border-radius: 20px;
    }
    .text {
        font-size: 14px;
    }
    .item {
        margin-bottom: 18px;
    }
    .clearfix {
        height: 38px;
        line-height: 38px;
        font-size: 12px;
        background: #fafafb;
        border-radius: 10px;
    }
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: '';
    }
    .clearfix:after {
        clear: both;
    }
    .error {
        color: #ed1d25;
        padding-left: 10px;
    }
    .operat {
        padding: 0 15px;
        height: 24px;
        margin-bottom: 24px;
    }

    .fixed {
        top: 50px;
        left: 140px;
        z-index: 999;
        padding-right: 60px;
        padding-left: 30px;
        width: calc(100% - 140px);
        height: 62px;
        position: fixed;
        transform: translateX();
        background-color: #f3f3f5;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
        line-height:73px;
        transition-duration: 1s;
    }
    .fixed-1 {
        left: 60px;
        transition-duration: 1s;
    }
    .btn-icon {
        margin-right: 27px;
        cursor: pointer;
        .btn-text {
            position: relative;
            top: -4px;
            font-size: 15px;
            padding-left: 5px;
            color: #0062ff;
        }
        .ban {
            color: #666;
        }
    }
    .el-button--danger {
        background-color: #e50113;
    }
    .el-button--info {
        background-color: #bbbbbb;
        border-color: #bbbbbb;
    }
    /deep/.el-table__header-wrapper {
        thead {
            background-color: rgba(80, 181, 255, 0.1);
            .el-table-column--selection {
                .el-checkbox {
                    visibility: hidden;
                }
            }
        }
    }
    .el-divider--horizontal {
        margin-top: 7px;
    }
    .icon {
        outline: none;
    }
}
</style>
